import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    if (!this.element.open) return
    this.element.open = false
    this.element.querySelector("summary").focus()
  }

  leave(event) {
    if (event.relatedTarget && !this.element.contains(event.relatedTarget)) this.element.open = false
  }
}
